export interface ClientStoreClientOptions {
    appClient?: boolean;
}
